var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"refContainer"},[_c('div',{style:({ height: _vm.height + 'px' }),attrs:{"id":"container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }